import { DirhamIcon } from 'ui-component/custom-icons/icons';

export const numberFormatter = new Intl.NumberFormat('en-US', {
	style: 'decimal',
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
});

export const getCurrencySymbol = (currency, defaultCurrency) => {
	if (currency === 'usd') {
		return '$';
	} else if (currency === 'aed') {
		return 'AED';
	} else if (currency === 'eur') {
		return '€';
	} else if (currency === 'all') {
		if (defaultCurrency === 'usd') {
			return '$';
		} else if (defaultCurrency === 'aed') {
			return 'AED';
		} else if (defaultCurrency === 'eur') {
			return '€';
		} else {
			return '';
		}
	}
};
export const getCurrencySymbolV2 = (currency, defaultCurrency, height, width) => {
	if (currency === 'usd') {
		return '$';
	} else if (currency === 'aed') {
		return <DirhamIcon height={height} width={width} style={{ marginTop: '-2px' }} />;
		// return 'AED';
	} else if (currency === 'eur') {
		return '€';
	} else if (currency === 'all') {
		if (defaultCurrency === 'usd') {
			return '$';
		} else if (defaultCurrency === 'aed') {
			return <DirhamIcon height={height} width={width} style={{ marginTop: '-2px' }} />
		} else if (defaultCurrency === 'eur') {
			return '€';
		} else {
			return '';
		}
	}
};
export const getCurrencySymbolV3 = (currency, defaultCurrency) => {
	if (currency === 'usd') {
		return '$';
	} else if (currency === 'aed') {
		return 'Ð';
	} else if (currency === 'eur') {
		return '€';
	} else if (currency === 'all') {
		if (defaultCurrency === 'usd') {
			return '$';
		} else if (defaultCurrency === 'aed') {
			return 'Ð';
		} else if (defaultCurrency === 'eur') {
			return '€';
		} else {
			return '';
		}
	}
};

export const calculateRateValue = (baseValue, baseRate, toCurrencyRate) => {
	return numberFormatter.format((Number(baseValue) / Number(baseRate)) * Number(toCurrencyRate));
};

export const currencyObject = [
	{ label: 'ALL', value: 'all' },
	{ label: 'EUR', value: 'eur' },
	{ label: 'USD', value: 'usd' },
	{ label: 'AED', value: 'aed' }
];
